export const FETCH_CUSTOM_PAGE_URL = '/page/customJson';
